export default __webpack_public_path__ + "static/media/cartHV.1eb8a1aa.svg";